import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * Wrap a route element with this to require authentication.
 * Unauthenticated users get redirected to /login with a `from` query param
 * so we can send them back after they log in.
 */
export default function ProtectedRoute({ children, requireRole }) {
  const { isAuthed, user } = useAuth();
  const location = useLocation();

  if (!isAuthed) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (requireRole && user?.role !== requireRole) {
    // Logged in but wrong role — send to a forbidden page (or back to login for now)
    return <Navigate to="/login?forbidden=1" replace />;
  }

  return children;
}